(() => {
  const drawer = document.querySelector("[data-cart-drawer]");
  const overlay = document.querySelector("[data-cart-overlay]");
  const items = document.querySelector("[data-cart-items]");
  const footer = document.querySelector("[data-cart-footer]");
  const total = document.querySelector("[data-cart-total]");
  const root = window.Shopify?.routes?.root || "/";

  const money = cents => {
    const currency = window.Shopify?.currency?.active || "USD";
    return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
      style: "currency",
      currency
    }).format(cents / 100);
  };

  const escapeHtml = value => {
    const element = document.createElement("div");
    element.textContent = value || "";
    return element.innerHTML;
  };

  const openCart = () => {
    if (!drawer || !overlay) return;
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    overlay.hidden = false;
    document.body.classList.add("locked");
  };

  const closeCart = () => {
    if (!drawer || !overlay) return;
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    overlay.hidden = true;
    document.body.classList.remove("locked");
  };

  const renderCart = cart => {
    document.querySelectorAll("[data-cart-count]").forEach(node => {
      node.textContent = cart.item_count;
    });

    if (!items || !footer) return;
    footer.hidden = cart.item_count === 0;

    if (cart.item_count === 0) {
      items.innerHTML = `
        <div class="drawer__empty">
          <p>Your bag is empty.</p>
          <a class="text-link" href="${root}collections/all">Choose your standard</a>
        </div>`;
      return;
    }

    items.innerHTML = cart.items.map(item => `
      <article class="cart-line" data-cart-key="${escapeHtml(item.key)}">
        ${item.image ? `<img src="${escapeHtml(item.image)}&width=240" alt="">` : ""}
        <div>
          <h3>${escapeHtml(item.product_title)}</h3>
          <p>${escapeHtml(item.variant_title || "")}</p>
          <p>${money(item.final_line_price)}</p>
          <button class="text-button" type="button" data-cart-remove="${escapeHtml(item.key)}">Remove</button>
        </div>
      </article>
    `).join("");

    if (total) total.textContent = money(cart.total_price);
  };

  const refreshCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("Could not load bag.");
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  document.addEventListener("click", async event => {
    if (event.target.closest("[data-cart-open]")) {
      event.preventDefault();
      try { await refreshCart(); } catch (_) {}
      openCart();
      return;
    }

    if (event.target.closest("[data-cart-close]") || event.target === overlay) {
      closeCart();
      return;
    }

    const remove = event.target.closest("[data-cart-remove]");
    if (!remove) return;
    remove.disabled = true;
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 })
      });
      if (!response.ok) throw new Error("Could not remove item.");
      renderCart(await response.json());
    } catch (error) {
      remove.disabled = false;
    }
  });

  document.querySelectorAll(".product-form").forEach(form => {
    const status = form.querySelector("[data-product-status]");
    const submit = form.querySelector("[data-add-to-cart]");
    const select = form.querySelector("[data-variant-select]");
    const price = form.closest("[data-product-root]")?.querySelector("[data-product-price]");

    select?.addEventListener("change", () => {
      const option = select.selectedOptions[0];
      if (price) price.textContent = option.dataset.price;
      const available = option.dataset.available === "true";
      submit.disabled = !available;
      submit.textContent = available ? "Add to bag" : "Sold out";
    });

    form.addEventListener("submit", async event => {
      event.preventDefault();
      submit.disabled = true;
      if (status) status.textContent = "Adding to bag…";

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error("This selection could not be added.");
        await refreshCart();
        if (status) status.textContent = "";
        openCart();
      } catch (error) {
        if (status) status.textContent = error.message;
      } finally {
        const available = !select || select.selectedOptions[0]?.dataset.available === "true";
        submit.disabled = !available;
      }
    });
  });

  document.addEventListener("keydown", event => {
    if (event.key === "Escape") closeCart();
  });
})();
